// extracted by mini-css-extract-plugin
export var contact = "Hero-module--contact--My8n8";
export var icon = "Hero-module--icon--hhBdT";
export var img = "Hero-module--img--UtsoP";
export var root = "Hero-module--root--i2d80";
export var social = "Hero-module--social--qRq5I";
export var txt = "Hero-module--txt--zwoJv";
export var withIcon = "Hero-module--withIcon--aEsbd";